// extracted by mini-css-extract-plugin
module.exports = {"item":"SeriesList_item__2pSm6","completed":"SeriesList_completed__9jUhn"};